import ContainerCustom from "../../../Components/ContainerCustom";
import Table from "../../../Components/Table/Table";
import TableButton from "../../../Components/Buttons/TableButton";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config/api";
import Pagination, { buildPaginatedUrl, paginationFromResponse } from "../../../Components/Pagination/Pagination";
import LeverageModeDisplay from "../../../Components/LeverageModeDisplay";

export default function ChallengeList() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [activeFilter, setActiveFilter] = useState(categories.map(() => true));
  const [challenges, setChallenges] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ count: 0, totalPages: 0 });
  const [categoryPagination, setCategoryPagination] = useState({ page: 1, totalPages: 0 });
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const selectedCategories = categories.filter((_, index) => activeFilter[index]);
  const challengeListUrl = () => {
    const url = buildPaginatedUrl(`${API_BASE_URL}/api/v0/challenges/admin/`, page);
    if (categories.length && selectedCategories.length < categories.length) {
      return `${url}&category=${encodeURIComponent(selectedCategories.join(","))}`;
    }
    return url;
  };
  const fetchChallengesData = async () => {
    if (categories.length && selectedCategories.length === 0) {
      setChallenges([]);
      setPagination({ count: 0, totalPages: 0 });
      setLoading(false);
      return;
    }
    setLoading(true); setError("");
    try {
      let response = await fetch(
        challengeListUrl(),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
            challengeListUrl(),
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Categories Data:", data);
      const parsed = paginationFromResponse(data, page);
      if (parsed.totalPages > 0 && page > parsed.totalPages) {
        setPage(1);
        return;
      }
      setChallenges((current) =>
        page === 1 ? parsed.results : [...current, ...parsed.results],
      );
      setPagination(parsed);
    } catch (error) {
      console.error("Error fetching categories data:", error);
      setError("خطا در دریافت لیست چالش‌ها");
    } finally {
      setLoading(false);
    }
  };
  const fetchCategoriesData = async (categoryPage = 1) => {
    setCategoriesLoading(true);
    try {
      let response = await fetch(
        buildPaginatedUrl(`${API_BASE_URL}/api/v0/challenges/admin/categories/`, categoryPage, 100),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          buildPaginatedUrl(`${API_BASE_URL}/api/v0/challenges/admin/categories/`, categoryPage, 100),
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Categories Data:", data);
      const parsed = paginationFromResponse(data, categoryPage);
      setCategories((current) => categoryPage === 1 ? parsed.results : [...current, ...parsed.results]);
      setCategoryPagination({ page: parsed.page, totalPages: parsed.totalPages });
    } catch (error) {
      console.error("Error fetching categories data:", error);
    } finally {
      setCategoriesLoading(false);
    }
  };
  useEffect(() => {
    fetchChallengesData();
  }, [page, activeFilter, categories]);
  useEffect(() => {
    fetchCategoriesData(1);
  }, []);
  useEffect(() => {
    setActiveFilter(categories.map(() => true));
  }, [categories]);
  useEffect(() => {
    setPage(1);
    setChallenges([]);
  }, [activeFilter]);
  return (
    <>
      <ContainerCustom
        header="لیست چالش‌ها"
        headSVG="archive"
        colorfulFilterOptions={categories.map((category) => ({
          SVGName: "star",
          text: category,
          className: "w-24",
          color: "blue",
        }))}
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
        filter={false}
        sort={false}
        search={false}
      >
        <Pagination page={categoryPagination.page} totalPages={categoryPagination.totalPages} loading={categoriesLoading} onPageChange={fetchCategoriesData} />
        <Table
          columns={[
            { key: "uuid", label: "کد چالش" },
            { key: "type", label: "نوع چالش" },
            {
              key: "class",
              label: "دسته چالش",
              render: (value, row) => {
                return (
                  <StatusColorful
                    SVGName="star"
                    text={row.class}
                    className="w-24"
                    color="blue"
                  />
                );
              },
            },
            { key: "name", label: "نام چالش" },
            { key: "leverage", label: "اهرم" },
            { key: "price", label: "قیمت چالش" },
            { key: "discountPercent", label: "درصد تخفیف" },
            { key: "discountPrice", label: "قیمت پس از تخفیف" },
            {
              key: "detail",
              label: "جزئیات",
              render: (value, row) => (
                <TableButton
                  text="مشاهده"
                  href=""
                  onClick={() => {
                    navigate(`/challenges/${row.uuid}/challenge-info`);
                  }}
                  className="!py-1 !px-2 !rounded-md bg-zi-bg1-light dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark"
                />
              ),
            },
          ]}
          data={
            challenges
              ? challenges.map((item) => ({
                    uuid: item.id,
                    type: item.challenge_type === "real" ? "واقعی" : "تمرینی",
                    class: item.category,
                    name: item.name,
                    leverage: (
                      <LeverageModeDisplay
                        mode={item.leverage_mode}
                        fixedLeverage={item.fixed_leverage ?? item.leverage}
                        allowedLeverages={item.allowed_leverages}
                      />
                    ),
                    price: `$${item.cost}`,
                    discountPercent: item.discount_percent
                      ? item.discount_percent
                      : "-",
                    discountPrice: item.discount_cost
                      ? `$${item.discount_cost}`
                      : `-`,
                    detail: "",
                  }))
              : []
          }
          loading={loading && page === 1}
          error={error}
          onRetry={fetchChallengesData}
          showEmptyState
          emptyMessage="نتیجه‌ای مطابق فیلترها یافت نشد"
        />
        <Pagination page={page} totalPages={pagination.totalPages} count={pagination.count} loading={loading} onPageChange={setPage} />
      </ContainerCustom>
    </>
  );
}
